<template>
  <Card>
    <h1 slot="Title">The Basic 6-Digit USSGL Accounts Classification</h1>
    <div slot="MainContent">
      <p>
        The normal balance indicates the account balance is usually a debit or credit.  If the normal balance for an account is a debit, then a debit to the account will increase the balance, while a credit will decrease the account.
      </p>
      <div class="ImageWrapper">
        <figure>
          <img :src="Image" alt="Informational Graph">
        </figure>
      </div>
    </div>
    <p><strong>The basic 6-digit USSGL accounts classification</strong></p>
<p>The general ledger utilizes double-entry bookkeeping, when a transaction occurs, it always affects two of these accounts in equal and opposite ways;&nbsp; it is a debit to one and a credit to another.&nbsp; The total amount of debits should always equal the total amount of credits, so if the two do not match up, it indicates that an error has been made.&nbsp; This comprehensive and balanced format is one reason why the account ledger is used to create financial statements.&nbsp;</p>
<p>USSGL accounts appearing in bold are new or indicate a change from the last USSGL TFM Supplement release (changes to the title, normal balance, and/or definition).</p>
<p>The entire account number series are 100000-900000.&nbsp; The 900000 series of accounts are available for agencies to record and maintain agency-specific statistical and/or memorandum data.</p>
<p><strong>Instructor</strong>:&nbsp; Have the students read the paragraph after <strong>&ldquo;The basic 6-digit USSGL accounts are classified as follows:&rdquo;, </strong>and research some of the accounts so that they may become familiar with the regulation.</p>
  </Card>
</template>
<style scoped>
  p {
    max-width: 70%;
    width: 100%;
  }

  ul > li {
    margin-bottom: 0;
  }

  .ImageWrapper {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }

  .ImageWrapper > figure > img {
    max-width: calc(1610px / 3);
    width: 100%;
    height: auto;
  }

</style>
<script>
import Card from '../../../components/Card.vue';

export default {

  components: {
    Card
  },
  name: 'General Ledger Account Categories',
  
  data() {
    return {
      Image: require('@/assets/The Basic 6-Digit USSGL Accounts Classification_150ppi.png')
    }
  }
  
}
</script>